import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top immediately when pathname changes
    window.scrollTo(0, 0);
    
    // Force a re-render of lazy components
    window.dispatchEvent(new Event('resize'));
  }, [pathname]);

  return null;
}
